import React from "react";
const StockName = (props) => {
    return (React.createElement("div", { className: "stockname" },
        React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1 mgr-5 lh-140" }, props.stockName)));
};
export default StockName;
